export default __webpack_public_path__ + "static/media/telegram.3fef0a30.svg";